import script from "./CotizacionDatos.vue?vue&type=script&setup=true&lang=js"
export * from "./CotizacionDatos.vue?vue&type=script&setup=true&lang=js"

import "./CotizacionDatos.vue?vue&type=style&index=0&id=46a32e8b&lang=css"

const __exports__ = script;

export default __exports__